import { formatAmount } from '@george-labs.com/design-system';

import type { Transaction } from '@shared/transactions-types';
import { getFeatureConfig } from '@luna/feature-config';

export const formatExchangeRate = ({
    exchangeRateValue,
    exchangeRatePrecision,
}: Transaction): string | null => {
    if (!exchangeRateValue) {
        return null;
    }

    const { decimalSeparator, thousandSeparator } = getFeatureConfig(({ base }) => base);

    const allowNegative = false;
    const precision = exchangeRatePrecision ?? 0;
    const formatOptions = { precision, allowNegative, decimalSeparator, thousandSeparator };

    return formatAmount(exchangeRateValue, formatOptions);
};
